module.exports = __webpack_public_path__ + "img/css3.5398ae12.svg";